import { Icon } from '@eventbrite/eds-icon';
import { NegativeIconFill } from '@eventbrite/eds-iconography';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import RebrandingDangerIcon from '../../resources/rebranding-danger-icon';

import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../utils/rebrand';

import defaultStyles from './FooterError.module.scss';
import rebrandStyles from './FooterError.rebranding.module.scss';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

export interface FooterErrorProps {
    className?: string;
    isAppRebrandActive?: boolean;
}

export const FooterError: FunctionComponent<FooterErrorProps> = ({
    children,
    className,
    isAppRebrandActive = false,
}) => {
    const icon = isAppRebrandActive ? (
        <RebrandingDangerIcon />
    ) : (
        <Icon type={<NegativeIconFill />} color="ui-red" />
    );

    const theme = getStyles(!!isAppRebrandActive);
    const styles = stylesModules[theme];

    return (
        <p
            role="alert"
            className={classNames(
                'eds-align--center-vertical eds-fx--fade-in',
                { 'eds-text-bm eds-text-color--error': !isAppRebrandActive },
                styles.validationErrorText,
                className,
            )}
            data-testid="footer-error"
        >
            <span className="eds-l-mar-right-1">{icon}</span>
            {children}
        </p>
    );
};
